import React from 'react';
import _ from 'lodash';


export default class ImageLoopTemplate{
	
	constructor(app){
		this.app = app;
	}

	async getScreens(){
		const newScreens = _.cloneDeep(screens);

		this.app.experiment.center({elements: newScreens[0].children[0].elements, horizontal:true, vertical:true});
		this.app.experiment.center({elements: newScreens[0].children[1].elements, horizontal:true} );

		let datasetName = this.app.experiment.getUniqueDataSetName("image-loop-dataset");
	
		newScreens[0].dataSetId = datasetName;

		const dataSet = {
			"id": datasetName,
			"rows": [
				["id",	"image"	],
				["1",	"image1"],
				["2",	"image2"],
				["3",	"image3"]
			]
		};

		this.app.experiment.data.dataSets.push(dataSet);

		await this.app.alert({label:'Image Loop Added', content:(<div>In order to use the Image Loop, upload images via the Media button, then make sure that the image IDs as listed in the Media Manager match the IDs as listed in the group's dataset (which is accessible by clicking on the "image-loop" group heading in the left-panel).<br /><br />Then, for however many images you list in that dataset, the participant will see each image, followed by the image-response screen, until all of the images in the dataset have been shown.</div>)})

		return newScreens;
	}
};

const screens = [
	{
		"useDataSet": true,
		"id": "image-loop",
		"isGroup": true,
		"dataSetId": "image-loop-dataset",
		"children": [
			{
				"autoAdvance": "1",
				"id": "image",
				"elements": [
					{
						"onClick": null,
						"x": 192,
						"width": 418,
						"y": 94,
						"id": "New Image",
						"type": "image",
						"url": "{row.image}",
						"height": 376
					}
				]
			},
			{
				"id": "image-response",
				"elements": [
					{
						"onClick": "{next}",
						"x": 151,
						"width": 480,
						"options": [
							"Strongly Disagree",
							"Disagree",
							"Neutral",
							"Agree",
							"Strongly agree"
						],
						"y": 118,
						"id": "multiple-choice",
						"text": "This image was interesting.",
						"type": "multiplechoice",
						"value": -1,
						"height": 300
					}
				]
			}
		]
	}
];




// WEBPACK FOOTER //
// ./src/models/templates/ImageLoopTemplate.js